import FlexBox from '@/atomic-components/FlexBox';
import { LencoImage } from '@/atomic-components/Image';
import { getColor } from '@/utils/theme/colors';
import { getStyle } from '@/utils/theme/fonts';
import { Box, Drawer } from '@mui/material';
import { LencoTypography } from '@/atomic-components/LencoTypography';
import { VariantConfiguration } from '.';
import TickIcon from '../../../../../assets/pdp/tick.svg';
import DeliveryTruckIcon from '../../../../../assets/pdp/deliveryIcon.svg';
import RightArrowWithColor from '../../../../../assets/pdp/rightArrowIconWithMintyColor.svg';
import RightArrowIcon from '../../../../../assets/pdp/rightArrowIcon.svg';
import CrossIcon from '../../../.././../assets/pdp/crossIcon.svg';
import InformationIcon from '../../../../../assets/pdp/infoIcon.svg';
import { useRouter } from 'next/router';
import { ListingService as ProductService } from '../../../../../services/catalogue/index';
import { useLocation } from '@/hooks/useLocation';
import LencoButton from '@/atomic-components/LencoButton';
import { emitMoeEvent } from '@/utils/dataLayer';
import { useState, useEffect } from 'react';

type ConfigModal = {
	variantConfiguration: VariantConfiguration;
	variantGroupId: number;
	label?: string;
	condition?: string;
	priceData: any;
	promiseDate: any;
	setConfiguration: Function;
	selectedTenure: number;
	setOpenConfigModel: any;
	openConfigModel: boolean;
	isAvailable: boolean;
	handleChange: (
		e: any,
		d: string,
		screen_name: string,
		isPdpConfigs?: boolean
	) => void;
};

const ConfigModal = (props: ConfigModal) => {
	const { url, aspect_ratio } = props?.variantConfiguration.product.medias[0];
	const { selectedLocation, locationActions } = useLocation();
	const currentlySelectedPincode = selectedLocation.pincode;

	const router = useRouter();
	let bundleConfig = '';

	const price =
		props?.variantConfiguration.product?.upfrontOffers?.paymentPlans?.filter(
			(pay: any) => {
				return pay.tenure == props?.selectedTenure;
			}
		)[0];
	const [tempConfig, setTempConfig] = useState<any>(null);

	useEffect(() => {
		if (props?.variantConfiguration) {
			setTempConfig(props?.variantConfiguration);
		}
	}, [props?.variantConfiguration, props?.openConfigModel]);

	const handleTempConfigChange = (
		value: any,
		configName: string,
		screen_name: string
	) => {
		const searchParams = new URLSearchParams();
		searchParams.append(`intent[${configName}]`, value);

		const configData = tempConfig.configurations.filter((config: any) => {
			return config.name !== configName;
		});

		const preselectedConfigs = configData?.map((data: any) => {
			return {
				name: data.name,
				filter: data?.options?.filter((d: any) => {
					return d.selected == true;
				})[0],
			};
		});

		preselectedConfigs.forEach((element: any) => {
			searchParams.append(`config[${element.name}]`, element.filter.value);
		});

		searchParams.append(
			'cityId',
			(selectedLocation.cityId?.toString() as string) ?? '1'
		);

		ProductService.getProductConfig(
			props.variantGroupId,
			searchParams.toString()
		)
			.then((res) => {
				setTempConfig(res.data.data);

				emitMoeEvent('Variant tapped', {
					variant_name: value,
					variant_category: configName,
					screen_name: screen_name,
				});
			})
			.catch((err) => {
				console.log(err);
			});
	};

	const handleConfirm = () => {
		props.setConfiguration(tempConfig);

		if (tempConfig?.product?.permalink) {
			router.push(`/products/${tempConfig.product?.permalink}`);
		}

		props.setOpenConfigModel(false);

		// if (handleConfirm && tempConfig.product) {
		// 	handleConfirm();
		// }
	};

	// const selected_data = tempProductData?.configurations?.map(
	// 	(d: any) =>
	// 		d?.options?.find((config: any) => config?.selected === true) || null
	// );

	// const handleChange = (e: any, d: string) => {
	// 	searchParams.append(`intent[${d}]`, e);
	// 	const configData = props.variantConfiguration.configurations.filter(
	// 		(config: any) => {
	// 			return config.name !== d;
	// 		}
	// 	);
	// 	const preselectedConfigs = configData?.map((data: any) => {
	// 		return {
	// 			name: data.name,
	// 			filter: data?.options?.filter((d: any) => {
	// 				return d.selected == true;
	// 			})[0],
	// 		};
	// 	});

	// 	preselectedConfigs.forEach((element: any) => {
	// 		searchParams.append(`config[${element.name}]`, element.filter.value);
	// 	});
	// 	searchParams.append(
	// 		'cityId',
	// 		(selectedLocation.cityId?.toString() as string) ?? '1'
	// 	);
	// 	ProductService.getProductConfig(
	// 		props.variantGroupId,
	// 		searchParams.toString()
	// 	)
	// 		.then((res) => {
	// 			props.setConfiguration(res.data.data);
	// 		})
	// 		.catch((err) => {
	// 			console.log(err);
	// 		});
	// };

	const isProductAvailable =
		props?.variantConfiguration === tempConfig
			? props?.isAvailable
			: tempConfig?.product?.isAvailable;

	const filterGrayScale = !isProductAvailable ? 'grayscale(100%)' : 'none';

	return (
		<Drawer
			anchor='right'
			open={props?.openConfigModel}
			onClose={() => props.setOpenConfigModel(false)}
		>
			<Box
				sx={{
					borderRadius: '16px',
					boxShadow: '0px -8px 16px rgba(34, 34, 34, 0.04)',
					maxWidth: '1200px',
					minWidth: '1080px',
				}}
				role='presentation'
			>
				<FlexBox direction='column' sx={{ padding: '80px' }}>
					<FlexBox
						sx={{
							width: '100%',
							justifyContent: 'space-between',
						}}
					>
						<FlexBox direction='column'>
							<LencoTypography
								sx={{
									...getStyle('H9A_Medium'),
									fontStyle: 'italic',
									color: '#222222',
								}}
							>
								Configure
							</LencoTypography>
							<LencoTypography
								sx={{
									...getStyle('P_Medium'),
									color: getColor('Gray -2'),
									marginBottom: '40px',
								}}
							>
								{props.variantConfiguration?.product?.title}
							</LencoTypography>
						</FlexBox>
						<Box
							onClick={() => props.setOpenConfigModel(false)}
							sx={{ cursor: 'pointer' }}
						>
							<CrossIcon />
						</Box>
					</FlexBox>

					<FlexBox
						columnGap={4}
						sx={{
							position: 'relative',
						}}
					>
						<Box
							key={url}
							sx={{
								width: '50%',
								height: '540px',
								background:
									'linear-gradient(180deg, #FFFFFF 0.09%, #F3F3F3 100%)',
								filter: filterGrayScale,
							}}
						>
							<LencoImage url={url} aspectRatio={aspect_ratio} />
						</Box>
						{!isProductAvailable && (
							<FlexBox
								sx={{
									background: getColor('Danger -4'),
									padding: '0 16px 0 16px',
									height: '20px',
									borderRadius: '0px 10px 10px 0px',
									position: 'absolute',
									top: 16,
									justifyContent: 'center',
									alignItems: 'center',
								}}
							>
								<LencoTypography
									sx={{
										...getStyle('Tiny_Medium'),
										color: getColor('Gray -1'),
									}}
								>
									OUT OF STOCK
								</LencoTypography>
							</FlexBox>
						)}

						<FlexBox direction='column' sx={{ flexWrap: 'wrap', width: '50%' }}>
							<FlexBox direction='column' sx={{ flexWrap: 'wrap' }}>
								{tempConfig?.configurations?.map((configs: any, index: any) => {
									const selectedConfig = configs.options.filter(
										(d: any) => d.selected
									);
									bundleConfig =
										index == 0
											? bundleConfig + selectedConfig[0].value
											: bundleConfig + ' + ' + selectedConfig[0].value;
									return (
										<FlexBox
											direction='column'
											key={index}
											sx={{ paddingBottom: '16px' }}
										>
											<LencoTypography
												sx={{
													...getStyle('H14-Medium '),
													color: getColor('Gray -1'),
													paddingBottom: '8px',
												}}
											>
												{configs.label} :
											</LencoTypography>
											<FlexBox gap={2} sx={{ flexWrap: 'wrap' }}>
												{configs.options.map((d: any, index: any) => {
													const borderColor = d.selected
														? 'Minty +1'
														: 'Gray -4';
													const bgColor = d.selected ? 'Navy -6' : '#FFFFFF';
													return (
														<>
															<FlexBox
																key={index}
																onClick={() =>
																	handleTempConfigChange(
																		d.value,
																		configs.name,
																		'variant_page'
																	)
																}
																sx={{
																	backgroundColor: getColor(`${bgColor}`),
																	border: `1px solid ${getColor(
																		`${borderColor}`
																	)}`,
																	padding: '8px 18px 8px 18px',
																	borderRadius: '4px',
																	cursor: 'pointer',
																	'&:hover': {
																		backgroundColor: getColor('Minty +1'),
																		color: getColor(''),
																	},
																}}
															>
																{d.selected && (
																	<Box sx={{ paddingRight: '4px' }}>
																		<TickIcon />
																	</Box>
																)}
																<LencoTypography
																	id='typo'
																	sx={{
																		...getStyle('Small_SemiBold'),
																		whiteSpace: 'nowrap',
																		paddingTop: '2px',
																	}}
																>
																	{d.value}
																</LencoTypography>
															</FlexBox>
														</>
													);
												})}
											</FlexBox>
										</FlexBox>
									);
								})}
							</FlexBox>
							<LencoTypography
								sx={{
									...getStyle('P_Medium'),
									paddingTop: '40px',
									color: getColor('Gray -2'),
								}}
							>
								{props?.condition == 'RENT'
									? props?.condition
									: props?.condition?.split('_').join(' ')}
							</LencoTypography>
							<LencoTypography
								sx={{
									...getStyle('H9A_Medium'),
									color: getColor('Gray 0'),
								}}
							>
								{props?.variantConfiguration?.product?.title}
							</LencoTypography>

							<FlexBox gap={1} sx={{ alignItems: 'center' }}>
								<LencoTypography
									sx={{
										...getStyle('P_Medium'),
										fontSize: '18',
										color: getColor('Minty +1'),
									}}
								>
									{bundleConfig}
								</LencoTypography>
								{!isProductAvailable && (
									<FlexBox>
										<Box>
											<InformationIcon />
										</Box>
										<LencoTypography
											sx={{
												...getStyle('Tiny_Medium'),
												color: getColor('Danger +1'),
												paddingLeft: '4px',
											}}
										>
											Item out of stock
										</LencoTypography>
									</FlexBox>
								)}
							</FlexBox>

							<FlexBox sx={{ paddingTop: '24px' }}>
								<LencoTypography
									sx={{
										...getStyle('H14_Regular'),
										color: getColor('Gray -4'),
										textDecoration: 'line-through',
									}}
								>
									{props.condition == 'RENT'
										? price?.strikePrice.displayValue
										: props.variantConfiguration?.product?.priceBreakUp
												?.strikePrice.displayValue}
								</LencoTypography>
							</FlexBox>

							<LencoTypography
								sx={{ ...getStyle('H10A_SemiBold'), color: '#222222' }}
							>
								{price?.monthlyRental?.displayValue
									? price?.monthlyRental?.displayValue
									: props.variantConfiguration?.product?.priceBreakUp?.basePrice
											?.displayValue}
							</LencoTypography>
							<FlexBox sx={{ paddingTop: '40px' }}>
								<FlexBox sx={{ paddingTop: '2px', paddingBottom: '40px' }}>
									<Box>
										<DeliveryTruckIcon />
									</Box>

									{isProductAvailable ? (
										<LencoTypography
											sx={{
												...getStyle('Small_Medium'),
												color: getColor('Gray -4'),
												paddingLeft: '8px',
												whiteSpace: 'nowrap',
											}}
										>
											Get it by
											<LencoTypography
												component='span'
												sx={{
													...getStyle('Small_SemiBold'),
													color: getColor('Gray -2'),
													paddingLeft: '8px',
												}}
											>
												{props.promiseDate.displayValue}{' '}
												<LencoTypography
													component='span'
													sx={{
														...getStyle('Small_Medium'),
														color: getColor('Gray -4'),
													}}
												>
													to
												</LencoTypography>
											</LencoTypography>
										</LencoTypography>
									) : (
										<LencoTypography
											sx={{
												...getStyle('Small_SemiBold'),
												color: getColor('Danger -2'),
												paddingLeft: '8px',
												whiteSpace: 'nowrap',
											}}
										>
											OUT OF STOCK{' '}
											<LencoTypography
												component='span'
												sx={{
													...getStyle('Small_SemiBold'),
													color: getColor('Gray -4'),
													whiteSpace: 'nowrap',
												}}
											>
												&nbsp;at
											</LencoTypography>
										</LencoTypography>
									)}
									<LencoTypography
										component='span'
										sx={{
											...getStyle('Small_SemiBold'),
											color: getColor('Gray -2'),
											paddingLeft: '8px',
										}}
									>
										{currentlySelectedPincode}
									</LencoTypography>
								</FlexBox>
								<FlexBox
									onClick={() => {
										emitMoeEvent('PDP Promise Date Pincode Clicked');
										locationActions.triggerCitySelector(true);
									}}
								>
									<LencoTypography
										sx={{
											color: getColor('Minty +1'),
											textDecoration: 'underline',
											cursor: 'pointer',
											whiteSpace: 'nowrap',
											paddingLeft: '8px',
											...getStyle('P_Medium'),
											'&:hover': {
												...getStyle('P_SemiBold'),
												transform: 'scaleX(1.1)',
											},
										}}
									>
										change pincode
									</LencoTypography>
									<Box sx={{ paddingLeft: '8px', paddingTop: '2px' }}>
										<RightArrowWithColor />
									</Box>
								</FlexBox>
							</FlexBox>
							<LencoButton
								variant='contained'
								disabled={!isProductAvailable}
								sx={{
									height: '48px',
								}}
								onClick={() => {
									handleConfirm();
								}}
							>
								<LencoTypography sx={{ ...getStyle('P_SemiBold') }}>
									CONFIRM & CONTINUE
								</LencoTypography>
								<RightArrowIcon />
							</LencoButton>
						</FlexBox>
					</FlexBox>
				</FlexBox>
			</Box>
		</Drawer>
	);
};

export default ConfigModal;
